module.exports = __webpack_public_path__ + "images/emoji/musical_keyboard.bbcb6c1e8d7647441692.png";